export enum testAnalyticsTypes {
    FETCH_TEST_ANALYTICS_BY_ID = 'FETCH_TEST_ANALYTICS_BY_ID',
    SET_TEST_ANALYTICS = 'SET_TEST_ANALYTICS',
}
